export default "__VITE_PUBLIC_ASSET__3ddc7524__"